import { CalendarDate } from '@internationalized/date';
import {
  UpdateBillInput,
  PaymentMethod,
  BillLineItemInput,
  MoneyInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type BillUpdateParams = {
  id: string;
  documentDate?: CalendarDate | null;
  documentNumber?: string | null;
  eligibleAt?: CalendarDate | null;
  preferredPaymentMethod?: PaymentMethod | null;
  notes?: string | null;
  amount?: MoneyInput | null;
  facilityId?: string | null;
  lineItems?: BillLineItemInput[];
};

export const billUpdateAtom = createMutationAtomFactory(
  'finance.billUpdate',
  (params: BillUpdateParams) => {
    const input: UpdateBillInput = {};

    if (params.documentDate !== undefined) {
      input.documentDate = params.documentDate?.toString() ?? null;
    }
    if (params.documentNumber !== undefined) {
      input.documentNumber = params.documentNumber;
    }
    if (params.eligibleAt !== undefined) {
      input.eligibleAt = params.eligibleAt?.toString() ?? null;
    }
    if (params.preferredPaymentMethod !== undefined) {
      input.preferredPaymentMethod = params.preferredPaymentMethod;
    }
    if (params.notes !== undefined) {
      input.notes = params.notes;
    }
    if (params.amount !== undefined) {
      input.amount = params.amount;
    }
    if (params.facilityId !== undefined) {
      input.facilityID = params.facilityId;
    }
    if (params.lineItems !== undefined) {
      input.lineItems = params.lineItems;
    }

    return {
      financeBillUpdate: {
        __args: {
          id: params.id,
          input,
        },
        id: true,
        documentNumber: true,
        status: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
